(function () {
  const metafieldsData = JSON.parse(
    document.getElementById('variant-metafields-data')?.textContent || '{}'
  );

  const descriptionEl = document.querySelector('.text-block--AYUttK0hGT3FLVjBvc__product_description_eKa9T3');

  const originalDescription = descriptionEl?.innerHTML || '';
  const aPedidoEl = document.getElementById('variant-a-pedido-text');

  function updateVariantContent(variantId) {
    const data = metafieldsData[String(variantId)];
    if (!data) return;

    if (descriptionEl) {
      descriptionEl.innerHTML = data.description
        ? data.description
        : originalDescription;
    }

    if (aPedidoEl) {
      aPedidoEl.style.display = data.a_pedido ? 'block' : 'none';
    }
  }

  document.addEventListener('variant:change', function (e) {
    if (e.detail?.variant?.id) {
      updateVariantContent(e.detail.variant.id);
    }
  });

  document.querySelectorAll('[name="id"]').forEach(function (input) {
    input.addEventListener('change', function () {
      updateVariantContent(this.value);
    });
  });

  const selectedInput = document.querySelector('[name="id"]:checked, [name="id"]');
  if (selectedInput?.value) {
    updateVariantContent(selectedInput.value);
  }
})();
